module.exports = __webpack_public_path__ + "static/media/summary_box.f7acbeee.svg";